import ClientBadge from '@fingerprinting/features/client/common/client-badge'

import { getColor, getChildren } from './utils'

import type { TApplicationStatusType } from '@fingerprinting/types'
import type { IClientBadgeProps } from '@fingerprinting/features/client/common/client-badge'

interface IClientApplicationStatusProps extends IClientBadgeProps {
  status?: TApplicationStatusType | string
}

export default function ClientApplicationStatus({
  status,
  children,
  color: colorProps,
  ...props
}: IClientApplicationStatusProps) {
  const color = getColor(status)
  return (
    <ClientBadge color={colorProps ?? color} {...props}>
      {children ?? getChildren(status)}
    </ClientBadge>
  )
}
